export default ({...props}) => {
  const {size, space} = props.theme
  return `
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: ${size(12.5)}vw;
    height: calc(100vh - ${size(24.375)}px);
    top: ${space(6.875)}px;
    left: 0;
    z-index: 1000;
    background-color: rgb(245, 247, 249);

    & div.container {
      display: flex;
      align-items: center;
      flex-flow: column;
      gap: ${space(1.5)}px;
      padding: ${space(2.5)}px
    }

    @media screen and (max-width: 480px) {
      top: 0;
      height: ${size(12.5)}%;
    }
    `
}
